import minBy from 'lodash/minBy'
import { VIRTUAL_CURRENCY_GROUP, BONUSES_GROUPS, PREMIUM_SHOP_GROUP } from '@/constants'
import { fixIsoDate } from '@/helpers'

export default {
  cardByCode: state => code => state.cards.find(c => c.cardCode === code),

  cardsByTags: state => tags => state.cards.filter(c => tags.includes(c.tag)),

  firstBoundCard: state => state.cards.length
    ? minBy(state.cards, ({ boundAt }) => +new Date(fixIsoDate(boundAt)))
    : null,

  /**
   * All accrual bonuses sums (like boosters) for all active cards and all games
   * @param state
   * @param getters
   * @returns {T[]}
   */
  accrualsBonusSumsAllCards: state => state.bonuses.filter(bonusRecord => BONUSES_GROUPS.includes(bonusRecord.accrualGroup)),

  /**
   * All accrual currencies sums (like gold) for all active cards and all games
   * @param state
   * @param getters
   * @returns {T[]}
   */
  accrualsCurrenciesSumsAllCards: state => state.bonuses.filter(a => a.accrualGroup === VIRTUAL_CURRENCY_GROUP),

  /**
   * All accrual bonuses grouped by games
   * @param state
   * @param getters
   */
  accrualsBonusSumsByGames (state, getters) {
    const result = {}
    getters.accrualsBonusSumsAllCards.forEach(a => {
      if (result[a.game]) {
        result[a.game].push(a)
      } else {
        result[a.game] = [a]
      }
    })
    return result
  },

  /**
   * All accrual currencies grouped by games
   * @param state
   * @param getters
   */
  accrualsCurrenciesSumsByGames (state, getters) {
    const result = {}
    getters.accrualsCurrenciesSumsAllCards.forEach(a => {
      if (result[a.game]) {
        result[a.game].push(a)
      } else {
        result[a.game] = [a]
      }
    })
    return result
  },

  accrualsPremiumShopBonusAllCards: state => state.bonuses.filter(a => a.accrualGroup === PREMIUM_SHOP_GROUP)
}
